import { productGallery, cheapProductGallery } from '../images';

export const mainProduct = {
    id: 'strap-001',
    name: 'Фитили RP Versa Grips style',
    price: 19.99,
    image: productGallery[0],
    description: `Тези тежкотоварни ергономични lifting straps осигуряват сигурно, нехлъзгаво хващане по време на всички упражнения за дърпане, помагайки ви да вдигате по-тежко с по-малко умора на ръцете. Интегрираните подпори за китки осигуряват допълнителна стабилност и защитават от напрежение по време на мъртви тяги, лицеви опори, редове и други движения за дърпане.

Изработени от издръжлив PU материал с гъвкава, удобна подложка, те се вписват перфектно както за мъже, така и за жени. Отлични за бодибилдинг, силови тренировки и домашни тренировки.

Идеални за:
• Мъртва тяга
• Лицеви опори / Подтягания
• Тяга на лат машина
• T-бар редове / Щанга редове
• Машинни дърпания
• Тренировка на сила на хващането

⭐ Оценка: 4.7 / 5
📊 Отзиви: 131 (потвърдени покупки)
💰 Продажби: 3,000+

Материал: PU (полиуретан)
Метод на плетене: Нетекстилни материали
Подпорка за китка: Регулируема
Повърхност за хващане: Антихлъзгаща
Пол: Унисекс
Цвят: Зелен или Сив (избор при поръчка)
    Пакетът включва: 1 чифт (2 straps)`,
    images: productGallery,
    sizes: [],
    colors: ['Зелен', 'Сив']
};

export const cheapProduct = {
    id: 'strap-002',
    name: 'Girlfriend version',
    price: 13.99,
    image: cheapProductGallery[0],
    description: `Тези тежкотоварни ергономични lifting straps осигуряват сигурно, нехлъзгаво хващане по време на всички упражнения за дърпане, помагайки ви да вдигате по-тежко с по-малко умора на ръцете. Интегрираните подпори за китки осигуряват допълнителна стабилност и защитават от напрежение по време на мъртви тяги, лицеви опори, редове и други движения за дърпане.

Изработени от издръжлив PU материал с гъвкава, удобна подложка, те се вписват перфектно както за мъже, така и за жени. Отлични за бодибилдинг, силови тренировки и домашни тренировки.

Идеални за:
• Мъртва тяга
• Лицеви опори / Подтягания
• Тяга на лат машина
• T-бар редове / Щанга редове
• Машинни дърпания
• Тренировка на сила на хващането

⭐ Оценка: 4.7 / 5
📊 Отзиви: 131 (потвърдени покупки)
💰 Продажби: 3,000+

Материал: PU (полиуретан)
Метод на плетене: Нетекстилни материали
Подпорка за китка: Регулируема
Повърхност за хващане: Антихлъзгаща
Пол: Унисекс
Цвят: Сив
    Пакетът включва: 1 чифт (2 straps)`,
    images: cheapProductGallery,
    sizes: [],
    colors: []
};

export const products = [mainProduct, cheapProduct];
